import React, {useEffect, useState} from "react";
import "./appointment.css";
import Afterloginheader from "../../components/MainHeader/Afterloginheader";
import {toast} from "react-toastify";
import {IMAGE_URL} from "../../app_url";
import {useUserContext} from "../../context/UserContext";
import NoImage from "../../assets/images/no-image-avatar.png";
import {deleteFavoritDoctorApi, getFavoritDoctorApi} from "../../services/apiService";
import LoadingPage from "../../components/LoadingPage";
import {useNavigate} from "react-router";

const FavouriteDoctor = () => {
  const navigate = useNavigate();
  const {userData, setUserData} = useUserContext();
  const [screenLoading, setScreenLoading] = useState(true);
  const [doctorList, setDoctorList] = useState();

  const getFavoritDoctor = async () => {
    try {
      setScreenLoading(true);
      let response = await getFavoritDoctorApi();
      if (response) {
        if (response.data.res === true) {
          setDoctorList(response.data.data);
        } else {
          toast.error(response.data.msg, {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    } finally {
      setScreenLoading(false);
    }
  };

  const handleRemoveDoctor = async id => {
    try {
      setScreenLoading(true);
      let fd = new FormData();
      fd.append("id", id);
      let response = await deleteFavoritDoctorApi(fd);
      if (response) {
        if (response.data.res === true) {
          getFavoritDoctor();
        } else {
          toast.error(response.data.msg, {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    } finally {
      setScreenLoading(false);
    }
  };

  useEffect(() => {
    getFavoritDoctor();
  }, []);

  return (
    <div className="Main">
      <Afterloginheader />
      <div className="AppointmentBody">
        <div className="CustomContainer">
          <div className="AppointmentTopBox">
            <h3>Favourite Doctors</h3>
          </div>
        </div>
        {screenLoading ? <LoadingPage /> : null}
        <div className="favouriteDoctorMain">
          {doctorList && doctorList.length > 0 ? (
            <>
              {doctorList.map((item, index) => (
                <div className="cardContainer" key={index}>
                  <div className="head">
                    <div className="innerHead" onClick={() => navigate(`/search/doctor-details/${item?.doctor_details[0]?.slug}`)}>
                      <img src={item?.doctor_details[0]?.profile_pic_url ?  item?.doctor_details[0]?.profile_pic_url : NoImage} alt="" />
                      <div>
                        <h4>
                          {item?.doctor_details[0]?.first_name} {item?.doctor_details[0]?.last_name}
                        </h4>
                        <span>{item?.doctor_speciality[0]?.name}</span>
                      </div>
                    </div>
                    <button className="removeBtn" onClick={() => handleRemoveDoctor(item?.id)}>
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <>
              <div className="noDocFound">No doctors found!</div>{" "}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FavouriteDoctor;
